// Description: Works just like localStorage.setItem / localStorage.getItem
//              except it returns a javascript object instead of a json stirng.
//
// Note: Using object notation for name will not set/get item properties!
//       This is because the name is used as a name, not a path.
//
// History: 09/11/2017 ET Created service

angular.module('iqxCore')
.service('IqxLocalStorage', function () {
  svc = this
  var obj = {}
  if(localStorage.iqx){
    obj = JSON.parse(localStorage.iqx)
  }

  // private functions

  function updateLocalStorage(){
    localStorage.iqx = JSON.stringify(obj)
  }

  // shared functions
  svc.getItem = function(name){
    if(obj[name]){
      return obj[name]
    }else{
      return undefined
    }
  }
  svc.setItem = function(name, item){
    obj[name] = item
    updateLocalStorage()
  }

})
